import {
  AttachMoneyIcon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Switch,
  Text,
  TuneIcon,
} from '@billda/design-system';
import { PageHeaderAction } from '../../../../shared/components/layout/PageHeaderAction';

interface SitePlotsDisplayMenuProps {
  showValues: boolean;
  onShowValuesChange: (value: boolean) => void;
}

/**
 * SitePlotsDisplayMenu — Linear-style "Display" popover that lets users
 * toggle whether values (budget / price) are shown on plots and labour items.
 */
export function SitePlotsDisplayMenu({
  showValues,
  onShowValuesChange,
}: SitePlotsDisplayMenuProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <PageHeaderAction
          label="Display"
          icon={<TuneIcon />}
          data-testid="site-plots-display-button"
        />
      </PopoverTrigger>
      <PopoverContent
        id="site-plots-display-popover"
        align="start"
        aria-label="Site display options"
        className="mt-0.5 w-70 rounded-xl p-4"
      >
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <AttachMoneyIcon
              className="size-4 text-content-secondary"
              aria-hidden="true"
            />
            <Text variant="body2" color="secondary">
              Show values
            </Text>
          </div>
          <Switch
            checked={showValues}
            onCheckedChange={checked => onShowValuesChange(checked)}
            aria-label="Show values"
            data-testid="site-plots-show-values-toggle"
          />
        </div>
      </PopoverContent>
    </Popover>
  );
}
